import CoreSigmaModal from "./CoreSigmaModal";
import SigmaEventDefinitionSearchAction from "./SigmaEventDefinitionSearchAction";
const sigmaBindings = {
  "eventDefinitions.components.editSigmaModal": [
    {
      component: CoreSigmaModal,
      key: "coreSigmaModal"
    }
  ],
  "components.shared.entityActions": [
    {
      component: SigmaEventDefinitionSearchAction,
      key: "sigma-search-logs"
    }
  ]
};
export default sigmaBindings;
